'use strict';

angular.module('imagetrend.components')
    .controller('ConfirmModalController', ['$scope', '$uibModalInstance', 'message', function ($scope, $uibModalInstance, message) {
        $scope.message = message;

        $scope.yes = function () {
            $uibModalInstance.close(true);
        }

        $scope.no = function () {
            $uibModalInstance.close(false);
        }

        $scope.$on('$destroy', function () {
        });
    }])
;